<!-- TEMPLATE -->
<template>
  <div class="wrapper">
    <dean-dialog
        class="number-checker"
        title="Number checker"
        :icon="dashboardIcon"
        align-top>
      <div v-if="loading">
        <dean-spinner
            size="80"
            :full-circle="true"
        ></dean-spinner>
      </div>
      <div v-if="result" class="bottom">
        <dean-button primary="true" :disabled="inputFieldInvalid" warning dialog-button @click.native="showResult">
          Resultaat tonen
        </dean-button>
        <dean-button primary="true" :disabled="inputFieldInvalid" warning dialog-button @click.native="newCall">
          Nieuwe aanvraag
        </dean-button>
      </div>
      <div v-if="!loading&&!result">
        <dean-input-field
            id="phoneNumber"
            v-model="phoneNumber"
            required-field="true"
            label="telefoonnummer"
            v-on:inputData="checkValue"
            text>
          Telefoonnummer
        </dean-input-field>
        <dean-button :primary="!inputFieldInvalid" :disabled="inputFieldInvalid" warning dialog-button
                     @click.native="clickCall">
          Check
        </dean-button>
      </div>
    </dean-dialog>
  </div>
</template>
<!-- SCRIPT -->
<script lang="ts">
  import Vue from 'vue';
  import axios from 'axios';
  import {Component, Prop, Watch} from 'vue-property-decorator';
  import {deanDialogBus} from '@/main';

  // DEAN COMPONENTS
  import {
    deanDialog,
    dashboardIcon,
    deanIcon,
    deanSpinner,
    deanInputField,
    deanButton,
  } from '@deanone/dean-components';

  @Component({
    components: {
      dashboardIcon,
      deanIcon,
      deanSpinner,
      deanInputField,
      deanDialog,
      deanButton,
    },
  })


  export default class NumberCheckerWidget extends Vue {
    public loading: boolean = false;
    public phoneNumberValid: string = '^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$';
    public dashboardIcon: object = dashboardIcon;
    public inputFieldInvalid: boolean = true;
    public phoneNumber: string = '';
    public result: any = null;
    public columns: any = {
      phoneNumber: {
        content: 'telefoon nr',
        align: 'left',
        sort: true,
        dql: 'code',
      },
      originalNetworkOperator: {
        content: 'originele operator',
        align: 'left',
        sort: true,
        dql: 'name',
      },
      currentNetworkOperator: {
        content: 'huidige operator',
        align: 'left',
        sort: true,
        dql: 'pchsnr',
      },
      effectiveSince: {
        content: 'effectief sinds',
        align: 'left',
        sort: true,
        dql: 'city',
      },
      typeOfNumbers: {
        content: 'soort nummer',
        align: 'left',
        sort: true,
        dql: 'partnerName',
      },
    };

    public newCall() {
      this.inputFieldInvalid = true;
      this.phoneNumber = '';
      this.result = null;
    }

    public showResult() {
      deanDialogBus.$emit('open', 'DetailsDialog', {
        title: 'Resultaten number check',
        data: [this.result],
        columns: this.columns,
      });
    }

    public checkValue(value: string) {
      this.inputFieldInvalid = true;
      const phoneNumber = this.phoneNumber.replace(/\s/g, '').replace(/-/g, '');
      if (phoneNumber.match(this.phoneNumberValid)) {
        this.inputFieldInvalid = false;
      }
    }

    /**
     * Call appshell view with results
     *
     * @param      {any}  event   The event
     */
    public clickCall(event: any) {
      const phoneNumber = this.phoneNumber.replace(/\s/g, '').replace('-', '');
      const url = '/-/trade/api/widgets.numberChecker';

      if (! phoneNumber.match(this.phoneNumberValid)) {
        this.$toast(this.$store.state.main.notification.messages.mobilePhoneNumberInvalid);

        return false;
      }

      this.loading = true;

      axios
        .post(url, {
          phoneNumber,
        })
        .then(
          (response) => {
            this.result = response.data;
          }).catch((e) => {
            switch (e.response.data.errors && e.response.data.errors[0].code) {
              case 'ERR_INVALID_PHONE_NUMBER':
                this.$toast(this.$store.state.main.notification.messages.mobilePhoneNumberInvalid);
                break;
              default:
                this.$toast(this.$store.state.main.notification.messages.couldNotReceiveData);
                break;
            }
          })
        .finally(() => {
          this.loading = false;
        });
    }
  }
</script>
<!-- STYLE -->
<style lang="scss" scoped>
  // IMPORT
  @import '~@deanone/dean-components/src/scss/vars';

  .dialog :deep {
    padding: 0;
  }

  .dialog :deep(.dean-dialog-container),
  .dialog :deep(.dean-dialog-content) {
    width: 100%;
    height: 100%;
  }
</style>
